
import { Vue, Component, Prop } from 'vue-property-decorator';
import ShipmentItem from '@/features/dashboard/components/widgets/recentShipments/ShipmentItem.vue';
import { RecentShipment } from '@/features/dashboard/types';
import { getMarkerStyle } from '@/features/common/helpers';

@Component({
  components: {
    ShipmentItem,
  },
})
export default class Content extends Vue {
  @Prop({ required: true }) shipments!: Array<RecentShipment>;

  @Prop({ required: true }) labelColors!: string[];

  private getMarkerStyle(
    status: 'created' | 'intransit' | 'delivered' | 'exception',
  ): string {
    const statuses = ['created', 'intransit', 'exception', 'delivered'];
    return getMarkerStyle(statuses.indexOf(status), this.labelColors);
  }

  private openDetails(tab: 'details' | 'tracking', shipment: RecentShipment) {
    this.$emit(
      'openDetails',
      {
        trackingNumber: shipment.trackingNo,
        carrierTrackingNumber: shipment.CarrierTrackingNo,
      },
      tab,
    );
  }
}
